/* eslint-disable security/detect-object-injection */
import React, { useContext, useEffect, useState } from 'react';
import AnimatedPageFade from '../../components/Animations/AnimatedPageFade';
import Dropdown from '../../components/Dropdown';
import ApplicationContext from '../../context/ApplicationContext';
import { arrayToObject, checkKeysInArray, handleValidation } from '../../helpers/CommonFunctions';
import RequiredField from '../../components/RequiredField';
import Label from '../../components/Label';
import IdentificationHeader from './IdentificationHeader';
import TypeDatePicker from '../../components/TypeDatePicker';
import moment from 'moment';
import ErrorMessage from '../../components/ErrorMessageDisplay';
import { dataService } from '../../services/data.service';
import BackButton from '../../components/Button/BackButton';
import NextButton from '../../components/Button/NextButton';
import { OcrKeys } from '../../helpers/OcrKeys';
import AnimatedImage from '../../components/Animations/AnimatedImage';
import { cdnURL } from '../../config';
import { identificationLanguageContent } from './IdentificationLanguageContent';
import { requiredLanguageContent } from '../../components/RequiredField/requiredLanguageContent';

function IdentificationDetails() {
    const { handlePage, idCardData, setIdCardData, setLoading, sessionData, selectedLanguage } = useContext(ApplicationContext);
    const [cardIssuer, setCardIssuer] = useState('');
    const [cardType, setCardType] = useState('');
    const [cardNumber, setCardNumber] = useState('');
    const [date,setDate]=useState('');
    const [month,setMonth]=useState('');
    const [year,setYear]=useState('');
    const [loader, setLoader] = useState(false);
    const [submitSelected, setSubmitSelected] = useState(false);
    const [dateError, setDateError] = useState('');
    const [pageLoading, setPageLoading] = useState(true);

    /**
     * The `changeHandler` function is used to handle changes in input fields and update the
     * corresponding state variables.
     */
    const changeHandler=(e)=>{
        let { id, value }=e.target;
        setDateError("");
        value = value.replace(/[A-Za-z\s]/g, "");
        switch (id) {
        case "digit-1":
            setDate(value);
            break;
        case "digit-2":
            setMonth(value);
            break;
        case "digit-3":
            setYear(value);
            break;
        default:
            break;
        }
    }

    /**
     * The handleSubmit function checks if a given date is valid and not in the past, and if so, it
     * proceeds to the next page.
     */
    const handleSubmit = () => {
        let dateString = `${month}/${date}/${year}`;
        if(!moment(dateString, 'MM/DD/YYYY', true).isValid()) {
            setDateError('Invalid date format')
        } else if(moment().isAfter(moment(dateString, 'MM/DD/YYYY'))) {
            setDateError('Expiration date cannot precede the current date');
        } else {
            setLoader(true);
            const payload = {
                "card_issuer": cardIssuer,
                "card_type": cardType,
                "card_number": cardNumber,
                "card_expiration_date": moment(dateString, 'MM/DD/YYYY').valueOf(),
                "card_image": idCardData.card_image,
                "upload_type": idCardData.upload_type,
                "process_ocr": false
            }
            dataService.updateIDDetails(sessionStorage.getItem('session'), payload).then((res) => {
                if(res.error === false) {
                    setLoader(false);
                    setLoading(true);
                    handlePage('insurance', '', '', sessionData['review'] === 'previous' ? 'previous' : '')
                }
            })
        } 
    }

    const getIdentityCardDetails = () => {
        dataService.getIDCardDetails(sessionStorage.getItem('session')).then((res) => {
            if(res.error === false) {
                if(res.data.data?.process_ocr === true) {
                    handleProcessOcr(res.data.data.card_image, res.data.data);
                } else {
                    setIdCardData(res.data.data);
                    setCardIssuer(res.data.data.card_issuer);
                    setCardType(res.data.data.card_type);
                    setCardNumber(res.data.data.card_number);
                    let dateString = moment(res.data.data.card_expiration_date).format('MM/DD/YYYY');
                    dateString = dateString.split('/')
                    setMonth(dateString[0]);
                    setDate(dateString[1]);
                    setYear(dateString[2]);
                    setPageLoading(false);
                }
            }
        })
    }

    const handleClearData = () => {
        // setDate('');
        // setYear('');
        // setMonth('');
        // setCardNumber('');
    }

    function handleProcessOcr(image, idData) {
        let result = ''
        const payload = {
            key: image
        }
        dataService.processOcr(sessionStorage.getItem('session'), payload).then((res) => {
            if(res.error === false) {
                ['card_type', 'card_number', 'card_issuer', 'expiry_date'].map((item) => {
                    switch(item) {
                    case 'card_type': 
                        const type = checkKeysInArray(res.data, OcrKeys['card_type']);
                        if(type && type.includes('driver')) {
                            setCardType('Drivers License');
                        } else if(type && type.includes('state')) {
                            setCardType('State ID')
                        } else {
                            setCardType('');
                        }
                        const type1 = checkKeysInArray(arrayToObject(res.data.layouts), OcrKeys['card_type']);
                        if(type1 && type1.includes('driver')) {
                            setCardType('Drivers License');
                        } else if(type1 && type1.includes('state')) {
                            setCardType('State ID')
                        } else {
                            setCardType('');
                        }
                        break
                    case 'expiry_date': const result1 = checkKeysInArray(res.data, OcrKeys['expiry_date']);
                        if(result1) {
                            let dateString = moment(result1).format('MM/DD/YYYY');
                            if(dateString !== 'Invalid date') {
                                dateString = dateString.split('/');
                                setMonth(dateString[0] || '');
                                setDate(dateString[1] || '');
                                setYear(dateString[2] ||  '');
                            }
                        }
                        break
                    case 'card_number': 
                        const result2 = checkKeysInArray(res.data, OcrKeys['card_number']);
                        if(result2) {
                            setCardNumber(result2)
                        }
                        break
                    }
                })
                setIdCardData(idData);
                setPageLoading(false);
            } else {
                setPageLoading(false);
            }
        })
    }

    const handleBackNavigation = () => {
        if(idCardData.upload_type === 'capture') {
            handlePage('take_id_image', '', '', sessionData['review'] === 'previous' ? 'previous' : '')
        } else {
            handlePage('upload_id_image', '', '', sessionData['review'] === 'previous' ? 'previous' : '')
        }
    }

    useEffect(() => {
        getIdentityCardDetails();
    }, [])

    return (
        <AnimatedPageFade className={`flex flex-col ${pageLoading ? '' : 'justify-between'} relative h-welcome gradient-bg rounded-[16px] overflow-auto`}>
            <IdentificationHeader />
            <div className={`p-[8px] overflow-x-hidden overflow-y-auto options-height Form-scroll`}>
                {identificationLanguageContent['detail-info'][selectedLanguage]}
                <div className={`mt-[12px] ${selectedLanguage === 'ar' ? 'dir-rtl' : ''}`}>
                    <div className='relative'>
                        <Label labelID="card_issuer" disabled={false} labelName={identificationLanguageContent['card-issuer'][selectedLanguage]} isMandatory={true} />
                        {pageLoading
                            ?  <div className='animate-pulse h-[40px] mt-1 w-full bg-slate-300 rounded' />
                            :
                            <Dropdown
                                showErrorBorder={submitSelected && cardIssuer === ''} dropdownID="issuer" className="rounded" options={['State', 'Federal Government', 'Other']} selectedOption={cardIssuer} 
                                setSelectedOption={setCardIssuer} placeholder={identificationLanguageContent['Select an option'][selectedLanguage]} />
                        }
                    </div>
                    <div className='relative mt-[15px]'>
                        <Label labelID="card_type" disabled={false} labelName={identificationLanguageContent['card-type'][selectedLanguage]} isMandatory={true} />
                        {pageLoading
                            ?  <div className='animate-pulse h-[40px] mt-1 w-full bg-slate-300 rounded' />
                            :
                            <Dropdown callback={true} callbackFunction={handleClearData} 
                                showErrorBorder={submitSelected && cardType === ''} dropdownID="type" className="rounded" options={['Drivers License', 'State ID', 'Other']} selectedOption={cardType} setSelectedOption={setCardType} 
                                placeholder={identificationLanguageContent['Select an option'][selectedLanguage]} />
                        }
                    </div>
                    <div className='relative mt-[15px] w-full'>
                        <Label labelID="card_number" disabled={false} labelName={identificationLanguageContent['card-number'][selectedLanguage]} isMandatory={true} />
                        {pageLoading
                            ?  <div className='animate-pulse h-[40px] mt-1 w-full bg-slate-300 rounded' />
                            :
                            <input data-testid="card_number" maxLength={25}
                                autoComplete="off" type="text" id="card_number" value={cardNumber} onChange={(e) => {setSubmitSelected(false); setCardNumber(e.target.value)}}
                                className={`w-full mt-1 bg-[#F1F2F2] border ${submitSelected && cardNumber.trim() === '' ? 'border-[#B51803]' : 'border-[#797979]'} 
                        py-[10px]  px-[12px] rounded h-[40px] font-normal text-[#333] text-sm  outline-0  placeholder:text-sm placeholder:text-[#797979]`} placeholder={identificationLanguageContent['Enter card number'][selectedLanguage]} />
                        }
                    </div>
                    <div className='relative mt-[15px] w-full'>
                        <Label labelID="expiry_date" disabled={false} labelName={identificationLanguageContent['expiration-date'][selectedLanguage]} isMandatory={true} />
                        {pageLoading
                            ?  <div className='animate-pulse h-[40px] mt-1 w-full bg-slate-300 rounded' />
                            :
                            <TypeDatePicker changeHandler={changeHandler} dateError={dateError}  date={date} month={month} year={year} />
                        }
                    </div>
                    <ErrorMessage text={dateError} />
                    <span className='flex mt-[15px]'>
                        <RequiredField />
                        <p className='text-gray text-sm font-normal ml-2'> {requiredLanguageContent['required'][selectedLanguage]}</p>
                    </span>
                    {!pageLoading && <div className='mt-[24px] py-4'>
                        <div>
                            <div className='mt-3 max-h-[300px]'>
                                <AnimatedImage url={`https://${cdnURL}/${idCardData.card_image}`} className="object-contain max-h-[280px] mx-auto" alt="identity-front" />
                            </div>
                        </div>
                    </div>}
                </div>
            </div>
            {!pageLoading && <div className='flex mb-[24px] justify-between mx-[16px] w-auto fold-gap pt-[20px] gap-[12px]'>
                <BackButton disabled={loader} handleClick={() => handleBackNavigation()}  backType="previous" />
                <NextButton disabled={!handleValidation({cardIssuer, cardType, cardNumber, date, month, year}) || loader} handleClick={() => handleSubmit('upload_id_choice')} loader={loader} />
            </div>}
        </AnimatedPageFade>
    );
}

export default IdentificationDetails;